import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  CardTitle,
  Form,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import FileDownload from "js-file-download"
import Switch from "react-switch"
import { Slide, toast, ToastContainer } from "react-toastify"
import Select from "react-select"

const DataTableCandidat = props => {
  const [loading, setLoading] = useState(false)
  const [loadingBar, setLoadingBar] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [orders, setOrders] = useState([])
  const [edit, setEdit] = useState(0)
  const [add, setAdd] = useState(0)
  const [delet, setDelet] = useState(0)
  const [imp, setImp] = useState(0)
  const [excel, setExcel] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [etablissementOrigine, setEtablissementOrigine] = useState([])
  const [selectEtablissementOrigine, setSelectEtablissementOrigine] =
    useState("")
  const [diplome, setDiplome] = useState([
    { value: 4, label: "Mastère Professionnel" },
    { value: 5, label: "Mastère de Recherche" },
  ])
  const [selectDiplome, setSelectDiplome] = useState("")
  const [status, setStatus] = useState([
    { value: 1, label: "En attente" },
    { value: 2, label: "Validée" },
    { value: 3, label: "Admis" },
    { value: 4, label: "Refusée" },
    { value: 5, label: "Sur la liste d'attente" },
  ])
  const [selectStatus, setSelectStatus] = useState("")
  const [status1, setStatus1] = useState([
    { value: 1, label: "En attente" },
    { value: 2, label: "Validée" },
    { value: 3, label: "Admis" },
    { value: 4, label: "Refusée" },
    { value: 5, label: "Sur la liste d'attente" },
  ])
  const [selectStatus1, setSelectStatus1] = useState("")
  const [etatValide, setEtatValide] = useState(0)
  const [etatValide1, setEtatValide1] = useState(0)
  const [statusName, setStatusName] = useState("")
  const [statusName1, setStatusName1] = useState("")
  const [candidature, setCandidature] = useState("")
  const [candidature1, setCandidature1] = useState("")
  const [specialiteCandidat, setSpecialiteCandidat] = useState("")
  const [specialiteCandidat1, setSpecialiteCandidat1] = useState("")
  const [score, setScore] = useState(0)
  const [score1, setScore1] = useState(0)
  const [scoreMin, setScoreMin] = useState(0)
  const [scoreMax, setScoreMax] = useState(0)
  const [modalNotif, setModalNotif] = useState(false)
  const [modalAfficher, setModalAfficher] = useState(false)
  const [modalNotifTous, setModalNotifTous] = useState(false)
  const [modalAfficherTous, setModalAfficherTous] = useState(false)
  const [modalGeneAuto, setModalGeneAuto] = useState(false)
  const [modalReinitialisation, setModalReinitialisation] = useState(false)
  const [modalSuppTous, setModalSuppTous] = useState(false)
  const [modalModifEtat, setModalModifEtat] = useState(false)
  const [candidat, setCandidat] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "name",
      text: (
        <>
          Nom de <br /> {"l'étudiant"}
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cin",
      text: props.t("CIN"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "email",
      text: props.t("Email "),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite1",
      text: (
        <>
          Spécialité <br /> choisie 1
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 3) {
          const firstLine = words.slice(0, 3).join(" ")
          const rest = words.slice(3).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "score1",
      text: (
        <>
          Score <br /> spécialité 1
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite2",
      text: (
        <>
          Spécialité <br /> choisie 2
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 3) {
          const firstLine = words.slice(0, 3).join(" ")
          const rest = words.slice(3).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "score2",
      text: (
        <>
          Score <br /> spécialité 2
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "etablissement",
      text: props.t("Etablissement"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 3) {
          const firstLine = words.slice(0, 3).join(" ")
          const rest = words.slice(3).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },

    {
      dataField: "Consultation",
      isDummyField: true,
      text: props.t("Consultation"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={"/ViewCandidat?id=" + row.cin}>
            <i
              style={{ color: "cornflowerblue", cursor: "pointer" }}
              className="fas fa-eye"
            ></i>
          </Link>
        </div>
      ),
    },

    {
      dataField: "notif",
      isDummyField: true,
      text: "Notifier",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        add === 1 ? (
          row.etat_candidature == 1 ? (
            <i
              style={{ color: "#8BA503", cursor: "pointer" }}
              className="fas fa-mail-bulk"
              onClick={() => toggleNotif(row)}
            ></i>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-mail-bulk"
                title={
                  "Vous ne pouvez pas modifier le statut de la candidature après sa validation."
                }
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-mail-bulk"
              title={"Vous n'avez pas d'accès"}
            ></i>
          </div>
        ),
    },
    {
      dataField: "show",
      isDummyField: true,
      text: (
        <>
          Afficher <br /> résultat
        </>
      ),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        add === 1 ? (
          row.etat_candidature == 1 ? (
            <i
              style={{ color: "#FF96A5", cursor: "pointer" }}
              className="fas fa-eye"
              onClick={() => toggleAfficher(row)}
            ></i>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-eye"
                title={
                  "Vous ne pouvez pas modifier le statut de la candidature après sa validation."
                }
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-eye"
              title={"Vous n'avez pas d'accès"}
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        imp === 1 ? (
          <a
            href={
              "https://scolarite.backcresus-institut.ovh/api/master/candidat/" +
              row.id +
              "/pdf/" +
              annee_id
            }
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <i
              style={{ color: "#FF679D", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </a>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </div>
        ),
    },

    {
      dataField: "status",
      isDummyField: true,
      text: "Status",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        add === 1 ? (
          row.etat_candidature == 1 ? (
            <i
              style={{ color: "#ffa501", cursor: "pointer" }}
              className="fas fa-check"
              onClick={() => toggle(row)}
            ></i>
          ) : (
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-check"
              title={
                "Vous ne pouvez pas modifier le statut de la candidature après sa validation."
              }
            ></i>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-check"
              title={"Vous n'avez pas d'accès"}
            ></i>
          </div>
        ),
    },
    {
      dataField: "edit_status",
      isDummyField: true,
      text: (
        <>
          Annuler la <br /> validation <br />
          de condidat
        </>
      ),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        delet === 1 ? (
          <i
            style={{ color: "#cc0909", cursor: "pointer" }}
            className="fas fa-times"
            onClick={() => toggleModifEtat(row)}
          ></i>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-times"
              title={"Vous n'avez pas d'accès"}
            ></i>
          </div>
        ),
    },
  ]
  const { SearchBar } = Search
  const getPermission = permissionName => {
    const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || []

    const permissions = userAuth.flatMap(user =>
      user.sous_menu.filter(subMenu => subMenu.sous_menu === permissionName)
    )

    return {
      add: Math.max(...permissions.map(p => Number(p.add || 0))),
      edit: Math.max(...permissions.map(p => Number(p.edit || 0))),
      delete: Math.max(...permissions.map(p => Number(p.delete || 0))),
      exel: Math.max(...permissions.map(p => Number(p.exel || 0))),
      imp: Math.max(...permissions.map(p => Number(p.imp || 0))),
    }
  }
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const permission = getPermission("Liste des candidats")
    setAdd(permission.add)
    setEdit(permission.edit)
    setDelet(permission.delete)
    setExcel(permission.exel)
    setImp(permission.imp)
    const res = await API.post("master/candidat/list", { annee_id }).then(
      res => {
        setOrders(res.data.Candidats)
      }
    )
    setLoading(true)
    const resMaster = API.post("master/specialite_master/select", {
      annee_id,
    }).then(resMaster => {
      setSpecialite(resMaster.data.Specialites)
    })
    const resEtablissement = await API.get(
      "master/etablissement_origine/select"
    ).then(resEtablissement => {
      setEtablissementOrigine(resEtablissement.data.Etablissement)
    })
  }, [])
  const optionsAvecAutre = [
    ...etablissementOrigine,
    // { label: "Autre", value: "autre" },
  ]
  const toggle = row => {
    setModal(!modal)
    setSelectStatus("")
    setSelectStatus1("")
    setCandidature(row.candidature1_id)
    setCandidature1(row.candidature2_id)
    setSpecialiteCandidat(row.specialite1)
    setSpecialiteCandidat1(row.specialite2)
    setScore(row.score1)
    setScore1(row.score2)
    setStatusName(row.statut1)
    setStatusName1(row.statut2)
  }
  const toggleModifEtat = row => {
    setModalModifEtat(!modalModifEtat)
    setCandidat(row.id)

  }
  const toggleNotif = row => {
    setModalNotif(!modalNotif)
    setCandidature(row.id)
  }
  const toggleNotifTous = row => {
    setModalNotifTous(!modalNotifTous)
  }
  const toggleAfficher = row => {
    setModalAfficher(!modalAfficher)
    setCandidature(row.id)
  }
  const toggleAfficherTous = row => {
    setModalAfficherTous(!modalAfficherTous)
  }
  const toggleSuppTous = row => {
    setModalSuppTous(!modalSuppTous)
  }
  const toggleGeneAuto = row => {
    setModalGeneAuto(!modalGeneAuto)
  }
  const toggleReinitialisation = row => {
    setModalReinitialisation(!modalReinitialisation)
  }
  const valider = async () => {
    if (selectStatus != "") {
      const res = await API.post("master/candidat/update_statut", {
        id: candidature,
        annee_id: annee_id,
        user_id: user_id,
        statut_id: selectStatus.value,
      }).then(res => {
        toast.success(" Votre status a été modifier avec succès", {
          containerId: "A",
        })
        setModal(false)
        setSelectStatus("")
        const resD = API.post("master/candidat/list", { annee_id }).then(
          res => {
            setOrders(res.data.Candidats)
          }
        )
        setLoading(true)
      })
    }
    if (selectStatus1 != "") {
      const res = await API.post("master/candidat/update_statut", {
        id: candidature1,
        annee_id: annee_id,
        user_id: user_id,
        statut_id: selectStatus1.value,
      }).then(res => {
        toast.success(" Votre status a été modifier avec succès", {
          containerId: "A",
        })
        setModal(false)
        setSelectStatus1("")
        const resD = API.post("master/candidat/list", { annee_id }).then(
          res => {
            setOrders(res.data.Candidats)
          }
        )
        setLoading(true)
      })
    }
  }
  useEffect(() => {
    setModal(false)
  }, [orders])
  const search = async () => {
    const specialite_master_id =
      selectSpecialite !== "" && selectSpecialite != null
        ? selectSpecialite.value
        : 0
    const etablissement_origine_id =
      selectEtablissementOrigine !== "" && selectEtablissementOrigine != null
        ? selectEtablissementOrigine.value
        : 0
    const statut_id =
      selectStatus !== "" && selectStatus != null ? selectStatus.value : 0
    const diplome_id =
      selectDiplome !== "" && selectDiplome != null ? selectDiplome.value : 0
    const score_min = scoreMin !== "" && scoreMin != null ? scoreMin : 0
    const score_max = scoreMax !== "" && scoreMax != null ? scoreMax : 0

    setOrders([])
    const res = await API.post("master/candidat/filtrer_liste_candidats", {
      specialite_master_id,
      etablissement_origine_id,
      statut_id,
      diplome_id,
      score_min,
      score_max,
      annee_id,
    }).then(res => {
      setOrders(res.data.Candidats)
    })
  }
  const searchAll = async () => {
    setSelectSpecialite("")
    const res = await API.post("master/candidat/list", { annee_id }).then(
      res => {
        setOrders(res.data.Candidats)
      }
    )
  }
  const generationAuto = async () => {
    setLoadingBar(true)
    try {
      const res = await API.post("master/candidature/affectation_candidature", {
        annee_id,
        user_id,
      })
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        API.post("master/candidat/list", { annee_id }).then(resCa => {
          setOrders(resCa.data.Candidats)
          setModalGeneAuto(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
        })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const ReinitialisationCandidature = async () => {
    setLoadingBar(true)
    try {
      const res = await API.post(
        "master/candidature/reinitialisation_candidature",
        { annee_id, user_id }
      )
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        API.post("master/candidat/list", { annee_id }).then(resCa => {
          setOrders(resCa.data.Candidats)
          setModalReinitialisation(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
        })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const uploadExcelLicence = async () => {
    const specialite_master_id =
      selectSpecialite !== "" && selectSpecialite != null
        ? selectSpecialite.value
        : 0
    const etablissement_origine_id =
      selectEtablissementOrigine !== "" && selectEtablissementOrigine != null
        ? selectEtablissementOrigine.value
        : 0
    const statut_id =
      selectStatus !== "" && selectStatus != null ? selectStatus.value : 0
    const diplome_id =
      selectDiplome !== "" && selectDiplome != null ? selectDiplome.value : 0
    const score_min = scoreMin !== "" && scoreMin != null ? scoreMin : 0
    const score_max = scoreMax !== "" && scoreMax != null ? scoreMax : 0
    const res = await API.post(
      "master/candidat/export/ListeFiltre",
      {
        specialite_master_id,
        etablissement_origine_id,
        statut_id,
        diplome_id,
        score_min,
        score_max,
        annee_id,
      },
      { responseType: "blob" }
    ).then(res => {
      FileDownload(res.data, "liste des candidats.xlsx")
    })
  }
  const telechargerTousCandidat = async () => {
    window.open(
      "https://scolarite.backcresus-institut.ovh/api/master/candidat/pdf/all/" +
        annee_id,
      "_blank"
    )
  }
  const NotifierTousCandidat = async () => {
    API.post("master/notifications/send_global", {
      annee_id,
      user_id,
    }).then(res => {
      toast.success("✔️ Notif candidat a été envoyée avec succès !", {
        containerId: "A",
      })
    })
  }
  const AfficherTousCandidat = async () => {
    API.post("master/candidat/affichage_resultat_all", {
      annee_id,
      user_id,
    }).then(res => {
      toast.success(
        "✔️ Affichage de résultat candidat a été envoyée avec succès !",
        {
          containerId: "A",
        }
      )
    })
  }
  const SupprimerTousCandidat = async () => {
    API.post("master/candidat/delete_master", {
      annee_id,
      user_id,
    }).then(res => {
      toast.success(
        "✔️ Suppression de tous les candidats a été supprimée avec succès !",
        {
          containerId: "A",
        }
      )
    })
  }
  const ModifierEtatCandidat = async () => {
    API.post("master/candidat/devalider_candidat", {
      candidat_id:candidat,
      user_id,
    }).then(res => {
      toast.success(
        "✔️ Annulation de candidat a été modifiée avec succès !",
        {
          containerId: "A",
        }
      )
    })
  }
  const notif = row => {
    API.post("master/notifications/send_one", {
      annee_id,
      candidat_id: candidature,
      user_id,
    }).then(res => {
      toast.success("✔️ Notif candidat a été envoyée avec succès !", {
        containerId: "A",
      })
      setModalNotif(false)
    })
  }
  const afficher = row => {
    API.post("master/candidat/affichage_resultat", {
      annee_id,
      candidat_id: candidature,
      user_id,
    }).then(res => {
      toast.success(
        "✔️ Affichage de résultat de  candidat a été envoyée avec succès !",
        {
          containerId: "A",
        }
      )
      setModalAfficher(false)
    })
  }
  const textColor =
    statusName === "En attente"
      ? "orange"
      : statusName === "Validée"
      ? "blue"
      : statusName === "Admis"
      ? "green"
      : statusName === "Refusée"
      ? "red"
      : "gray"
  const textColor1 =
    statusName1 === "En attente"
      ? "orange"
      : statusName1 === "Validée"
      ? "blue"
      : statusName1 === "Admis"
      ? "green"
      : statusName1 === "Refusée"
      ? "red"
      : "gray"
  const telechargerDossierCandidature = async row => {
    try {
      const res = await API.post(
        "master/candidat/downloadAll",
        {
          annee_id,
          user_id,
          cin: row,
        },
        {
          responseType: "blob",
        }
      )
      const blob = new Blob([res.data], { type: "application/zip" })
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = downloadUrl
      link.download = `dossier_candidature_${row}.zip`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.error(error)
      toast.error("Erreur lors du téléchargement du dossier")
    }
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <CardTitle style={{ color: "#556ee6" }} className="h4">
                      Critéres de Recherches
                    </CardTitle>
                    <Form className="mt-4">
                      <Row>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Spécialité :
                            </Label>
                            <Select
                              options={specialite}
                              isSearchable={true}
                              value={selectSpecialite}
                              isClearable={true}
                              onChange={e => setSelectSpecialite(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {"Etablissement d'origine"} :
                            </Label>
                            <Select
                              options={optionsAvecAutre}
                              isSearchable={true}
                              value={selectEtablissementOrigine}
                              isClearable={true}
                              onChange={e => setSelectEtablissementOrigine(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {"Type de diplôme"} :
                            </Label>
                            <Select
                              options={diplome}
                              isSearchable={true}
                              isClearable={true}
                              value={selectDiplome}
                              onChange={e => setSelectDiplome(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Statut de la candidature :
                            </Label>
                            <Select
                              options={status}
                              isSearchable={true}
                              isClearable={true}
                              value={selectStatus}
                              onChange={e => setSelectStatus(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Score minimum")}
                            </Label>
                            <Input
                              lg="3"
                              type="number"
                              className="form-control"
                              placeholder={props.t("Score minimum")}
                              value={scoreMin}
                              onChange={e => setScoreMin(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Score maximum")}
                            </Label>
                            <Input
                              lg="3"
                              type="number"
                              className="form-control"
                              placeholder={props.t("Score maximum")}
                              value={scoreMax}
                              onChange={e => setScoreMax(e.target.value)}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {loadingBar && (
                          <div className="mt-3">
                            <div className="progress">
                              <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: "100%" }}
                              ></div>
                            </div>
                            <p className="text-center mt-2">
                              Traitement en cours...
                            </p>
                          </div>
                        )}
                      </Row>
                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Col lg="12">
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={search}
                          >
                            Rechercher
                          </button>
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={searchAll}
                          >
                            Afficher tout
                          </button>
                          {cloture !== 1 ? (
                            add === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#CA3C66",
                                  borderColor: "#CA3C66",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleGeneAuto}
                              >
                                {
                                  "Génération automatique du statut des candidatures"
                                }
                              </button>
                            ) : null
                          ) : null}
                          {cloture !== 1 ? (
                            add === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#CE6A6B",
                                  borderColor: "#CE6A6B",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleReinitialisation}
                              >
                                {"Réinitialiser les statuts des candidatures"}
                              </button>
                            ) : null
                          ) : null}
                          {cloture !== 1 ? (
                            excel === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#5784BA",
                                  borderColor: "#5784BA",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={uploadExcelLicence}
                              >
                                <i className="fas fa-file-excel font-size-18 align-middle me-2"></i>
                                {"Exportation tous les candidatures"}
                              </button>
                            ) : null
                          ) : null}
                          {cloture !== 1 ? (
                            imp === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#FF679D",
                                  borderColor: "#FF679D",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={telechargerTousCandidat}
                              >
                                <i className="fas fa-file-pdf font-size-18 align-middle me-2"></i>
                                {"Télécharger tous les candidatures"}
                              </button>
                            ) : null
                          ) : null}
                          {cloture !== 1 ? (
                            add === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#8BA503",
                                  borderColor: "#8BA503",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleNotifTous}
                              >
                                <i className="mdi mdi-email-multiple font-size-16 align-middle me-2"></i>
                                {
                                  "Notifier tous les candidatures après la validation"
                                }
                              </button>
                            ) : null
                          ) : null}
                          {cloture !== 1 ? (
                            add === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#FF96A5",
                                  borderColor: "#FF96A5",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleAfficherTous}
                              >
                                <i className="fa fa-eye font-size-16 align-middle me-2"></i>
                                {
                                  "Afficher le résultat pour les candidatures après la validation"
                                }
                              </button>
                            ) : null
                          ) : null}

                          {cloture !== 1 ? (
                            delet === 1 ? (
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#cc0909",
                                  borderColor: "#cc0909",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleSuppTous}
                              >
                                <i className="mdi mdi-trash-can font-size-16 align-middle me-2"></i>
                                {"Supprimer tous les candidatures"}
                              </button>
                            ) : null
                          ) : null}
                        </div>
                      </Col>
                    </div>

                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>

                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true} size="xl">
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {"Modification status d'inscription"}
        </ModalHeader>
        <ModalBody>
          <div>
            <Fragment>
              <Row>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Statut de la candidature à modifier :
                    </Label>
                    <Select
                      options={status}
                      isSearchable={true}
                      isClearable={true}
                      value={selectStatus}
                      onChange={e => setSelectStatus(e)}
                    />
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Choix 1 :</Label>
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {specialiteCandidat}
                    </span>
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Score 1 :</Label>
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {score}
                    </span>
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Status actuel 1 :
                    </Label>
                    <span style={{ color: textColor, fontWeight: "bold" }}>
                      {statusName}
                    </span>
                  </div>
                </Col>
              </Row>
              {specialiteCandidat1 != null &&
              score1 != null &&
              statusName1 != null ? (
                <Fragment>
                  <hr
                    style={{
                      width: "100%",
                      marginTop: "0.1%",
                      color: "black",
                    }}
                  />
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Statut de la candidature à modifier :
                        </Label>
                        <Select
                          options={status1}
                          isSearchable={true}
                          isClearable={true}
                          value={selectStatus1}
                          onChange={e => setSelectStatus1(e)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Choix 2 :
                        </Label>
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          {specialiteCandidat1}
                        </span>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Score 2 :
                        </Label>
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          {score1}
                        </span>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Status actuel 2 :
                        </Label>
                        <span style={{ color: textColor1, fontWeight: "bold" }}>
                          {statusName1}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Fragment>
              ) : null}
            </Fragment>
          </div>

          <div
            className="hvr-push"
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "15px",
            }}
          >
            <div>
              <Button color="info" className="btn-rounded " onClick={valider}>
                <i style={{ color: "white" }} className="far fa-thumbs-up"></i>
                OUI
              </Button>
            </div>
            <div>
              <Button onClick={toggle} color="danger" className="btn-rounded ">
                <i
                  style={{ color: "white" }}
                  className="far fa-thumbs-down"
                ></i>
                NON
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalNotif} toggle={toggleNotif} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleNotif}
          tag="h4"
        >
          {"Notifier candidature"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Êtes-vous sûr(e) de vouloir notifier cette candidature ?</p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button color="info" className="btn-rounded " onClick={notif}>
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleNotif}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalNotifTous} toggle={toggleNotifTous} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleNotifTous}
          tag="h4"
        >
          {"Notifier les candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Êtes-vous sûr(e) de vouloir notifier tous les candidature ?</p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={NotifierTousCandidat}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleNotifTous}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalAfficher} toggle={toggleAfficher} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleAfficher}
          tag="h4"
        >
          {"Afficher la résultat de candidature"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir afficher la résultat de cette
                candidature ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={afficher}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleAfficher}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalAfficherTous}
        toggle={toggleAfficherTous}
        centered={true}
      >
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleAfficherTous}
          tag="h4"
        >
          {"Afficher la résultat de tous les candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir afficher la résultat de tous
                candidatures ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={AfficherTousCandidat}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleAfficherTous}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalGeneAuto} toggle={toggleGeneAuto} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleGeneAuto}
          tag="h4"
        >
          {"Génération automatique du statut des candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir générer automatique du statut des
                candidatures ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={generationAuto}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleGeneAuto}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalReinitialisation}
        toggle={toggleReinitialisation}
        centered={true}
      >
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleReinitialisation}
          tag="h4"
        >
          {"Réinitialisation les statuts du candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir réinitialiser les statuts du
                candidatures ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={ReinitialisationCandidature}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleReinitialisation}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalSuppTous} toggle={toggleSuppTous} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleSuppTous}
          tag="h4"
        >
          {"Afficher la résultat de tous les candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Êtes-vous sûr(e) de supprimer tous candidatures ?</p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={SupprimerTousCandidat}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleSuppTous}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalModifEtat} toggle={toggleModifEtat} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleModifEtat}
          tag="h4"
        >
          {"Annuler la validation de candidat "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Êtes-vous sûr(e) de annuler la validation de candidat ?</p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={ModifierEtatCandidat}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleModifEtat}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableCandidat))
DataTableCandidat.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
